export default __webpack_public_path__ + "static/media/2004-AMCover.0e51da95.png";